import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Cookies Notice",
    description:
      "We use essential cookies to ensure this website functions correctly. We also use optional tracking cookies to help us understand how you interact with our site. These optional cookies will only be set with your consent.",
    acceptAllBtn: "Accept All",
    acceptNecessaryBtn: "Reject All",
    showPreferencesBtn: "Manage Individual Preferences",
  },
  preferencesModal: {
    title: "Manage Cookie Preferences",
    acceptAllBtn: "Accept All",
    acceptNecessaryBtn: "Reject All",
    savePreferencesBtn: "Accept Current Selection",
    closeIconLabel: "Close Modal",
    sections: [
      {
        title: "Cookie Usage",
        description:
          "We use cookies to support the essential functions of this website and to improve your browsing experience.",
      },
      {
        title: "Strictly necessary cookies",
        description:
          "These cookies are essential for the proper functioning of the website, for example for user authentication.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Name",
            domain: "Service",
            description: "Description",
            expiration: "Expiration",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Cookie set by Digital Community Platform for user authentication.",
              expiration: "Session",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Cookie set by Digital Community Platform for user authentication",
              expiration: "Session",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "This cookie is used to distinguish between humans and bots to protect the website from automated abuse. No personal data is collected.",
              expiration: "30 Minutes",
            },
          ],
        },
      },
      {
        title: "Analytics",
        description:
          "Cookies used for analytics help collect data that allows services to understand how users interact with a particular service. These insights allow services both to improve content and to build better features that improve the user’s experience.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Name",
            domain: "Service",
            description: "Description",
            expiration: "Expiration",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Cookie set by <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Expires after 12 days",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Cookie set by <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Session",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Enables storage related to analytics e.g. visit duration.";

export { translation, servicesLabel };
